export default "__VITE_ASSET__xMYFs2en__"